import React from 'react'
import { Grid } from '@mui/material'
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  ArrayInput,
  SimpleFormIterator,
  NumberInput,
  ListButton,
  TopToolbar
} from 'react-admin'

import BookName from 'resources/rule_books/BookName'
import useOnError from 'common/error'
import integer from 'common/validation'
import DomainIdEditorSelect from 'components/DomainIdEditorSelect'
import TypeSelect from 'resources/rule_books/TypeSelect'

const transform = data => {
  delete data.rules
  delete data.hashed_scope
  return data
}

const BookEditActions = () => (
  <TopToolbar>
      <ListButton />
  </TopToolbar>
)

const BookEdit = props => {
  const onError = useOnError()
  return (
    <Edit title={<BookName />}
          actions={<BookEditActions />}
          transform={transform}
          mutationOptions={{ onError }}
    >
        <SimpleForm>
          <TextInput source="name" multiline validate={required()} fullWidth/>
          <TextInput source="description" multiline validate={required()} fullWidth />
          <TextInput source="scope" multiline validate={required()} fullWidth/>
          <TextInput source="id" fullWidth disabled />
          <Grid container columnSpacing={2}>
            <Grid item xs={12} sm={4}>
                <DomainIdEditorSelect fullWidth validate={required()} optionText="name" optionValue="id" />
            </Grid>
            <Grid item xs={12} sm={3}>
                <NumberInput
                  source="priority"
                  fullWidth
                  min="1"
                  max="1000"
                  step="1"
                  validate={[required(), integer()]}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TypeSelect
                source="applies_to"
                fullWidth
                validate={required()}
              />
            </Grid>
          </Grid>
          <ArrayInput source="parameters" >
              <SimpleFormIterator inline>
                  <TextInput source="k" fullWidth label="name" helperText={false} validate={required()}/>
                  <TextInput source="v" label="value" helperText={false} validate={required()}/>
                  <SelectInput
                  source="type"
                  choices={[
                    { id: 'int', name: 'int' },
                    { id: 'float', name: 'float' },
                    { id: 'str', name: 'str' }
                  ]}
                  validate={required()}/>
              </SimpleFormIterator>
          </ArrayInput>
        </SimpleForm>
    </Edit>
  )
}

export default BookEdit
